/** @module ChangeTracking/EntryRef */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi/_base/underscore",
	"csi/def",
	"csi/heading/Ref",
	"csi/html",
	"csi/locale",
	"csi/reflection",
	"csi/xml"
], function(declare,domClass,_,def,Ref,html,locale,reflection,xml) {

	var BREADCRUMB_DEPTH = 4;

	/**
	 * Return true is given node is Revision Object
	 * @param {Object} node - result node
	 * @return {boolean}
	 */
	function isRevision(node){
		var rc = reflection.getClass(node.ActualType);
		return rc && rc.isRevision();
	}

	/**
	 * Search in cached results and return node with given url
	 * @param {Object} ctx - Context
	 * @param {string} url
	 * @return {Object} - result node
	 */
	function getNode(ctx, url){
		return ctx.cache.getNode(url);
	}

	return declare(Ref, {
		/**
		 * Do not resolve ref attribute to Node Name along referenced path; just query them as any other attribute.
		 * @param {Context} ctx
		 * @param {Heading} h
		 * @param {Spec} spec
		 * @return {Object}
		 */
		getQuerySpec: function(ctx, h, spec) {
			var qs = this.inherited(arguments);
			qs.id = h.m_id;
			if (h.m_id == xml.ATTR_NAME) {
				if(!h.m_nameOrig){ // filter by instance
					qs.id = "DomainInstance";
				} else if(h.m_nameOrig == "LogCurrentUser"){ // filter by Original User
					qs.id = "CurrentUser";
				}
			}
			if(h.m_nameOrig == "LogEntryContext"){ // filter by context
				if (ctx.view.changeLogInstanceType) {
					return null; // Disable filtering by context on instance
				}
				qs.id = "ContextInstance";
			} else if (h.m_nameOrig && h.m_nameOrig.startsWith("LogEntryContext")) {
				qs.notFilterable = true;
			}
			qs.path = null;
			return qs;
		},

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: render value for attribute in HTML
			var node = this._getReferencedNode(ctx, h);
			if (!node) {
				return false;
			}
			// For Context column skip changed node and proceed to it's parent node
			var bContext = (h.m_nameOrig == "LogEntryContext");
			var bContext1 = (h.m_nameOrig == "LogEntryContext1");
			var bContext2 = (h.m_nameOrig == "LogEntryContext2");
			var bContext3 = (h.m_nameOrig == "LogEntryContext3");
			var bContext4 = (h.m_nameOrig == "LogEntryContext4");

			if (bContext || bContext1 || bContext2 || bContext3 || bContext4){
				var instanceNode = getNode(ctx, node.OriginalContext);
				// We need crumb only for Context Column, so create it here, starting from instance node
				var crumb = this._createCrumb(ctx, instanceNode);
				var bRevision = isRevision(instanceNode);
				var parent = getNode(ctx, instanceNode.ParentContext);
				if (bContext && bRevision && parent){
					parent = getNode(ctx, parent.ParentContext);
				}
				if (!parent){
					// show our special shaded background if changed object has no context
					domClass.add(refNode,html.CSS_NOT_APPLICABLE);
					return false;
				}
				node = parent;

				if (bContext2 || bContext3 || bContext4) {
					parent = getNode(ctx, node.ParentContext);
					if (!parent){
						// show our special shaded background if changed object has no context
						domClass.add(refNode,html.CSS_NOT_APPLICABLE);
						return false;
					}
					node = parent;
				}

				if (bContext3 || bContext4) {
					parent = getNode(ctx, node.ParentContext);
					if (!parent){
						// show our special shaded background if changed object has no context
						domClass.add(refNode,html.CSS_NOT_APPLICABLE);
						return false;
					}
					node = parent;
				}

				if (bContext4) {
					parent = getNode(ctx, node.ParentContext);
					if (!parent){
						// show our special shaded background if changed object has no context
						domClass.add(refNode,html.CSS_NOT_APPLICABLE);
						return false;
					}
					node = parent;
				}
			}

			// Take care of FoodLabelDataSheet case where it's a Recipe FoodLabel and therefore shouldn't be navigated into
			let browseAnchorParams = {
				$URL:node.ActualNode, 
				$Type:node.ActualType
			};
			if (node.ActualType === "FoodLabelDataSheet" || node.ActualType === "FoodLabelDataSheetRevision") {
				let parentContext = getNode(ctx, node.ParentContext);
				let i = 0;
				while (parentContext && i < 4) {
					// If RecipeDataSheet is the parent of the FoodLabelDataSheet, it's a Recipe Label
					if (parentContext.ActualType === "RecipeDataSheet") {
						browseAnchorParams = {
							...browseAnchorParams,
							IsRecipeLabel: true  
						}
						break;
					}
					parentContext = getNode(ctx, parentContext.ParentContext);
					i++;
				}
			}

			var bInstance = (h.m_name == "Instance");
			// Now when we are at desired node, draw the node (and revision if available)
			var bRevision = isRevision(node);
			var anchor = node.Deleted || !def.canNavigateToType(node.ActualType) ? html.create("span", {}, refNode) : def.createBrowseAnchor(ctx, refNode, browseAnchorParams, h.m_link);
			var origName = this.getNodeDisplayName(ctx, node);
			if (bRevision){
				origName = locale.resource("Revision") + " " + origName;
				node = getNode(ctx, node.ParentContext);
				html.text(anchor || refNode, this.getNodeDisplayName(ctx, node));
				// Simulate revision pill with brackets in excel
				if (ctx.bExcel){
					html.create("span", {innerText: " ("+origName+")"}, refNode);
				} else {
					html.create("span", {"class":"csi-log-pill", innerText: origName}, refNode);
				}
			} else {
				if (bInstance){
					var currName = this.getNodeDisplayName(ctx, getNode(ctx, ctx.getNodeContext().CurrentContext));
					html.text(anchor || refNode, currName);
					var filterNames = ctx.view.getQueryValueAsLabel('DomainInstance');
					_.some(filterNames, function(name){
						if ( (origName != currName) && (origName.search(new RegExp(name, "i")) >= 0) ){
							html.create("span", {"class":"", innerText: " (" + origName + ")"}, refNode);
							return true;
						}
					});
				} else {
					html.text(anchor || refNode, origName);
				}
			}

			// For context column create icon Info with breadcrumb
			if (bContext){
				var tooltipId = "CSI_LOG_TOOLTIP_" + _.uniqueId();
				html.create("span", {"class":"csiActionIcon material-icons csi-log-context-crumb", innerText: "info_outline", id:tooltipId}, refNode, "first");
				// Introduce delay and create tooltip after dom node gets created (otherwise tooltip will have no node to attach to)
				var changeLogTableView = ctx.view; // reference to ChangeLogTable widget;
				changeLogTableView.tooltips.push({
					connectId: [tooltipId],
					position: ["below-centered"],
					label: crumb
				});
			}
			return true;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			var	node = ctx.getNode();
			return node.$URL;
		},

		/**
		 * Creates breadcrumb as deep as BREADCRUMB_DEPTH (used for context column tooltip)
		 * @param {Context} ctx
		 * @param {Object} node - result node
		 * return {DomNode}
		 */
		_createCrumb: function(ctx, node){
			var level = 0;
			var div = html.create("div", {});
			while ( (level <= BREADCRUMB_DEPTH) && node ){
				if (isRevision(node)){
					if (level){ // Don't show instance node in tooltip breadcrumb (level == 0 for instance node)
						var txt = locale.resource("Revision") + " " + this.getNodeDisplayName(ctx, node);
						html.create("span", {"class":"csi-log-pill", innerText: txt}, div, "first");
					}
					node = getNode(ctx, node.ParentContext);
					console.assert(!!node, "Change Log Context: revision has no parent");
				}
				if (level){
					html.create("span", {"class":"", innerText: this.getNodeDisplayName(ctx, node)}, div, "first");
					html.create("span", {"class":"csi-log-crumb-separator csiActionIcon iconCrumb"}, div, "first");
				}
				level++;
				node = node && getNode(ctx, node.ParentContext);
			}
			return div;
		}

	});
});